export const ModificationSourceList = ["ai"] as const;
export type ModificationSource = (typeof ModificationSourceList)[number];
